import React, { Component } from 'react'
import { imageAddress } from '../../../../utils/useful'
import Responsive from '../../../Responsive'

export default class PhotoMedia extends Component {
    state = {
        media: {}
    }
    componentDidMount() {
        this.props.filterMedia('image')
    }
    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">
                <div className="d-flex flex-wrap m-0 w-100 p-2 h-100">
                    {this.props.media?.image?.map((element) => {
                        return (
                            <Responsive className={'px-1'} width={this.props.width} media={{ xs: "4", }}>
                                <img className='w-100 br-10 cursor-pointer' style={{ objectFit: "cover", backgroundColor: "#F2F2F7", aspectRatio: '1/1', }} src={imageAddress(element.image)} />
                            </Responsive>
                        )
                    })}
                </div>
            </div>
        )
    }
}
